import {Axios, AxiosRequestConfig, AxiosResponse} from "axios";

export type ApiFetcherCallBackType<DataType> = (config: any) => Promise<AxiosResponse<DataType>>

export function apiFetcher<DataType>(url: string, axios: Axios, params?: {
    [key: string]: any
}, pageParam = 'after'): ApiFetcherCallBackType<DataType> {

    const axiosConfig: AxiosRequestConfig = {};
    if (params) {
        axiosConfig.params = params;
    }

    return (config: any) => {
        if (config.pageParam) {
            if (!axiosConfig.params) {
                axiosConfig.params = {};
            }
            if (config.pageParam !== 'first') {
                axiosConfig.params[pageParam] = config.pageParam;
            }
        }
        return axios.get<DataType>(url, axiosConfig)
    };
}